import React, { useCallback, useEffect, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import {
  setMsgTone,
  setMsgTone2,
  setcontactlist2,
  setVoiceRefresh,
  setShowingStatus,
  setShowingStatusVoice,
  setShowingStatusClass,
  setReadyButton,
  updateNotification,
  setAgentList,
  endInteraction,
  setinternalchatrefresh,
} from "../../redux/actions/actions";
import audiosound from "../../assets/IncomingMsgTone/msgtone.wav";
import audiosound2 from "../../assets/IncomingMsgTone/watsapp_notif.mp3";
import { ToastContainer, Flip } from "react-toastify";
import {
  BaseUrl,
  SocketUrl,
  frontendBaseurl,
} from "../../container/BaseUrl/BaseUrl";
import { io } from "socket.io-client";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import sessionExp from "../../assets/assets/images/session_expired.png";
import Navbar from "../../components/navbar-components/Navbar";
import Sidebar from "../../components/sidebar-components/Sidebar";
import NewIncomingRequest from "../../components/New-incoming-request-component/New-incoming-request.component";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mapStateToProps = (state) => {
  return {
    msgTone: state.data.msgTone,
    msgTone2: state.data.msgTone2,
    chat: state.data.chat,
    userChatID: state.contactListData.userChatID,
    contactList: state.contactListData.contactList,
    contactList2: state.data.contactList2,
    readyButton: state.contactListData.readyButton,
    showingStatus: state.contactListData.showingStatus,
    showingStatusVoice: state.contactListData.showingStatusVoice,
    showingStatusClass: state.contactListData.showingStatusClass,
    agentList: state.data.agentList,
  };
};

const Main = (props) => {
  const AvcUrl = localStorage.getItem("AvcUrl");
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const playRingSound = () => {
    audioRef.current.play();
  };

  useEffect(() => {
    if (props.msgTone2) {
      playRingSound2();
      props.setMsgTone2(false);
    }
  }, [props.msgTone2]);

  const audioRef2 = useRef(null);

  const playRingSound2 = () => {
    audioRef2.current.play();
  };

  const [open, setOpen] = React.useState(false);
  const timeoutRef = useRef(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const HandleContinue = () => {
    handleClose();
    loginbyDomain();
  };
  const HandleLogout = async () => {
    handleClose();
    let data = JSON.parse(localStorage.getItem("tokenAgent"));
    let userID = data.user_id;
    if (data) {
      await axios
        .post(
          BaseUrl + "/users/logoutnew/" + userID,
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.success == true) {
            localStorage.removeItem("AvayaUsername");
            localStorage.removeItem("tab");
            localStorage.removeItem("timer_connect_sec");
            localStorage.removeItem("AvayaPassword");
            localStorage.removeItem("AvayaDomain");
            localStorage.removeItem("client");
            localStorage.removeItem("statusValue");
            localStorage.removeItem("emailDisplay");
            localStorage.removeItem("timer_connect_min");
            localStorage.removeItem("tokenAgent");
            localStorage.removeItem("timer_status");
            localStorage.removeItem("NameDisplay");
            localStorage.removeItem("access_token");
            localStorage.removeItem("timer_connect_hour");
            localStorage.removeItem("EnableWEBRTC");
            localStorage.removeItem("ticketcrm");
            if (!localStorage.getItem("TenantId")) {
              window.location.href = "error.html";
            } else {
              const loginUrl = `${frontendBaseurl}/?tenantID=${encodeURIComponent(
                localStorage.getItem("TenantId")
              )}`;
              window.location.href = loginUrl;
            }
          }
        })
        .catch((err) => {});
    }
  };

  const handleInteraction = useCallback(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
     // handleClickOpen();
     console.log("hii")
    }, 7200000);
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", handleInteraction);
    window.addEventListener("keydown", handleInteraction);
    window.addEventListener("click", handleInteraction);

    return () => {
      clearTimeout(timeoutRef.current);
      window.removeEventListener("mousemove", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
      window.removeEventListener("click", handleInteraction);
    };
  }, [handleInteraction]);

  useEffect(() => {
    let socket = io(SocketUrl + `/${localStorage.getItem("TenantId")}`);
    socket.on("connect", async () => {
      const datas = await JSON.parse(localStorage.getItem("tokenAgent"));
      socket.emit("add-user", datas.id);
      console.log("Socket => Connected=>External", socket);
      //toast.success("Socket Connected");
    });
    socket.on("disconnect", (reason, details) => {
      // toast.error("Socket Disconnected !");
      // the reason of the disconnection, for example "transport error"
      console.log(reason);

      // the low-level reason of the disconnection, for example "xhr post error"
      // console.log(details.message);

      // // some additional description, for example the status code of the HTTP response
      // console.log(details.description);

      // // some additional context, for example the XMLHttpRequest object
      // console.log(details.context);
    });
    socket.on("reconnect", () => {
      console.log("reconnect");
    });
    socket.on("connect_error", (err) => {
      // toast.error("Socket Disconnected !");
      // the reason of the error, for example "xhr poll error"
      console.log(err.message);

      // some additional description, for example the status code of the initial HTTP response
      // console.log(err.description);

      // // some additional context, for example the XMLHttpRequest object
      // console.log(err.context);
    });
    socket.on("get-new-req", async (newUser) => {
      console.log("get-new-req", newUser);
      try {
        console.log("get-new-req inside", newUser);
        const datas = await JSON.parse(localStorage.getItem("tokenAgent"));
        const newReqAgent = [];
        let listrequest = {};
        console.log("get-new-req inside", newUser.agent);
        console.log("Login ID", datas.id);
        if (datas.id === newUser.agent) {
          listrequest = newUser;

          if (props.contactList && props.contactList2) {
            const filteredArray = props.contactList.filter(
              (item) => item.id !== listrequest.id
            );

            const filteredArraynew = props.contactList2.filter(
              (item) => item.id !== listrequest.id
            );

            if (filteredArray.length === 0 && filteredArraynew.length === 0) {
              newReqAgent.push(listrequest);
              props.setcontactlist2(newReqAgent);
              playRingSound();
              // props.setIncomingRequestRefresh(true);
            }
          } else {
            const filteredArraynew = props.contactList2.filter(
              (item) => item.id !== listrequest.id
            );
            if (filteredArraynew.length === 0) {
              newReqAgent.push(listrequest);
              props.setcontactlist2(newReqAgent);
              playRingSound();
            }
          }
        }
      } catch (error) {
        console.log("New incoming request error", error);
      }
    });
    socket.on("update-changestatus-supervisor", async (newStatus) => {
      console.log("update-changestatus-supervisor", newStatus);
      try {
        console.log("update-changestatus-supervisor", newStatus);
        const agent = await JSON.parse(localStorage.getItem("tokenAgent"));
        if (agent.user_id == newStatus.user_id) {
          console.log("showingStatus", props.showingStatus);
          if (props.showingStatus == "Connected") {
            loginbyDomain();
          } else {
            updateStatus(newStatus.status);
          }
        }
      } catch (error) {
        console.log("update-changestatus-supervisor", error);
      }
    });
    socket.on("update-force-logout", async (logoutAgent) => {
      console.log("update-force-logout", logoutAgent);
      try {
        const agent = await JSON.parse(localStorage.getItem("tokenAgent"));
        if (agent.user_id == logoutAgent.user_id) {
          localStorage.removeItem("AvayaUsername");
          localStorage.removeItem("tab");
          localStorage.removeItem("timer_connect_sec");
          localStorage.removeItem("AvayaPassword");
          localStorage.removeItem("AvayaDomain");
          localStorage.removeItem("client");
          localStorage.removeItem("statusValue");
          localStorage.removeItem("emailDisplay");
          localStorage.removeItem("timer_connect_min");
          localStorage.removeItem("tokenAgent");
          localStorage.removeItem("timer_status");
          localStorage.removeItem("NameDisplay");
          localStorage.removeItem("access_token");
          localStorage.removeItem("timer_connect_hour");
          localStorage.removeItem("EnableWEBRTC");
          localStorage.removeItem("ticketcrm");
          localStorage.removeItem("agentLoginTerminalId");
          localStorage.removeItem("storeTopicValue");
          if (!localStorage.getItem("TenantId")) {
            window.location.href = "error.html";
          } else {
            const loginUrl = `${frontendBaseurl}/?tenantID=${encodeURIComponent(
              localStorage.getItem("TenantId")
            )}`;
            window.location.href = loginUrl;
          }
          navigate("/");
        }
      } catch (error) {
        console.log("update-force-logout", error);
      }
    });
    socket.on("update-agent-status-recv", async (data) => {
      console.log("agent-status", data);

      props.setinternalchatrefresh(false);
      const datas = JSON.parse(localStorage.getItem("tokenAgent"));
      await axios
        .post(
          BaseUrl + `/users/allInternalUsers?agent_id=${datas.id}`,
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.success == true) {
            props.setAgentList(res.data.data);

            props.setinternalchatrefresh(false);
          } else {
            props.setAgentList([]);

            props.setinternalchatrefresh(false);
          }
        })
        .catch((err) => {});

      const UserExist = await props.agentList.find((user) => {
        if (
          user.reciverDetails[0].user_id == data.user_id ||
          user.senderDetails[0].user_id == data.user_id
        ) {
          return user;
        }
      });
      if (UserExist) {
        const updatedAgentList = props.agentList.map((client) => {
          if (client.reciverDetails[0].user_id === data.user_id) {
            return {
              ...client,
              reciverDetails: [
                {
                  ...client.reciverDetails[0],
                  agent_status: data.status,
                },
              ],
            };
          } else if (client.senderDetails[0].user_id === data.user_id) {
            return {
              ...client,
              senderDetails: [
                {
                  ...client.senderDetails[0],
                  agent_status: data.status,
                },
              ],
            };
          }
          return client;
        });
        props.setAgentList(updatedAgentList);
      } else {
        return;
      }
    });
    socket.on("get-new-req-conf", (newUser) => {
      props.endInteraction();
    });
    return () => {
      socket.disconnect();
    };
  }, [props.showingStatus, props.agentList]);

  const loginbyDomain = async () => {
    if (localStorage.getItem("voiceEnable") == "true") {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/login?username=${localStorage.getItem(
              "AvayaUsername"
            )}&password=${localStorage.getItem(
              "AvayaPassword"
            )}&domain=${localStorage.getItem("AvayaDomain")}`,
          {},
          {
            headers: {
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            localStorage.setItem("enableSDK", "true");
            localStorage.setItem("ssoToken", res.data.data.ssoToken);
            localStorage.setItem(
              "agentLoginTerminalId",
              res.data.data.agents[0].agentLoginId
            );
            localStorage.setItem(
              "agentUsername",
              res.data.data.agents[0].agentUsername
            );
            loginbyDomainforAgent(
              res.data.data.agents[0].agentLoginId,
              res.data.data.ssoToken,
              res.data.data.agents[0].agentUsername
            );
          } else {
            let data = await JSON.parse(localStorage.getItem("tokenAgent"));
            await axios
              .post(
                BaseUrl + "/users/updateAgentStatus/",
                {
                  status: "Ready",
                  userId: data.user_id,
                },
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                    tenantId: localStorage.getItem("TenantId"),
                  },
                }
              )
              .then((res) => {
                if (res.data.status) {
                  props.setShowingStatus("Ready");
                  localStorage.setItem("AgentStatus", "Ready");
                  props.setShowingStatusClass("showStatus");
                  props.setShowingStatusVoice("Not Connected");
                  props.setReadyButton(true);
                } else {
                  props.setShowingStatus("Connected");
                  localStorage.setItem("AgentStatus", "Connected");
                  props.setShowingStatusClass("showStatusConnected");
                  props.setShowingStatusVoice("Connected");
                  props.setReadyButton(false);
                }
              })
              .catch((err) => {
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
              });

            ErrorNotification("Voice LogIn", res.data.message);
          }
        })
        .catch(async (error) => {
          let data = await JSON.parse(localStorage.getItem("tokenAgent"));
          await axios
            .post(
              BaseUrl + "/users/updateAgentStatus/",
              {
                status: "Ready",
                userId: data.user_id,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                props.setShowingStatus("Ready");
                localStorage.setItem("AgentStatus", "Ready");
                props.setShowingStatusClass("showStatus");
                props.setShowingStatusVoice("Not Connected");
                props.setReadyButton(true);
              } else {
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
              }
            })
            .catch((err) => {
              props.setShowingStatus("Connected");
              localStorage.setItem("AgentStatus", "Connected");
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              props.setReadyButton(false);
            });

          ErrorNotification("Voice LogIn", res.data.message);
        });
    } else {
      updateStatus("Ready");
    }
  };
  const loginbyDomainforAgent = async (terminalId, ssoToken, agentUsername) => {
    if (!terminalId && !ssoToken) return;
    await axios
      .post(
        AvcUrl +
          `/voice/cct/agent/${terminalId}/login/${terminalId}?status=Ready`,
        {},
        {
          headers: {
            ssoToken: ssoToken,
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then(async (res) => {
        if ((res.data.status = "OK")) {
          let data = JSON.parse(localStorage.getItem("tokenAgent"));
          await axios
            .post(
              BaseUrl + "/users/updateAgentStatus/",
              {
                status: "Ready",
                userId: data.user_id,
                agentLoginTerminalId: terminalId,
                agentUsername: agentUsername,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                props.setShowingStatus("Ready");
                localStorage.setItem("AgentStatus", "Ready");
                props.setShowingStatusClass("showStatus");
                props.setShowingStatusVoice("Ready");
                props.setReadyButton(true);
              } else {
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
              }
            })
            .catch((err) => {
              props.setShowingStatus("Connected");
              localStorage.setItem("AgentStatus", "Connected");
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              props.setReadyButton(false);
            });
        } else {
          updateStatus("Ready");
          props.setShowingStatusVoice("Not Connected");
          ErrorNotification("Voice LogIn", error.message);
        }
      })
      .catch((error) => {
        updateStatus("Ready");
        props.setShowingStatusVoice("Not Connected");
        ErrorNotification("Voice LogIn", error.message);
      });
  };

  const updateStatus = async (value) => {
    if (!value) return;
    let data = await JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: data.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        props.setVoiceRefresh(false);
        if (res.data.status) {
          if (value == "Connected") {
            props.setShowingStatus(value);
            props.setShowingStatusClass("showStatusConnected");
            props.setShowingStatusVoice("Connected");
            localStorage.setItem("AgentStatus", "Connected");
            localStorage.removeItem("ssoToken");
            localStorage.removeItem("agentLoginTerminalId");
            localStorage.removeItem("agentUsername");
            localStorage.removeItem("statusValue");
            localStorage.removeItem("enableSDK");
            props.setReadyButton(false);
          } else if (value == "Ready") {
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus",value);
            props.setShowingStatusClass("showStatus");
            if (props.showingStatusVoice == "Not Connected") {
            } else {
              changeStatusVoice("Ready", "Ready");
            }
          } else {
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", 'Not Ready');
            props.setShowingStatusClass("showStatusRed");
            if (props.showingStatusVoice == "Not Connected") {
            } else {
              changeStatusVoice("Not Ready", "Not Ready");
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        //
      });
  };
  const changeStatusVoice = async (status, value2) => {
    if (localStorage.getItem("voiceEnable") == "true") {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/agent/${localStorage.getItem(
              "agentLoginTerminalId"
            )}/status?status=${status}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken")
                ? localStorage.getItem("ssoToken")
                : "",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            props.setShowingStatusVoice(value2);
            if (status == "Ready") {
              localStorage.removeItem("VoiceActivate");
            }
          } else {
            ErrorNotification("Voice Status", res.data.message);
            props.setShowingStatusVoice("Not Connected");
          }
        })
        .catch((error) => {
          ErrorNotification("Voice Status", error.message);
          props.setShowingStatusVoice("Not Connected");
        });
    }
  };

  const ErrorNotification = (headerMsg, msg) => {
    const randomChars = Math.random().toString(36).substring(2, 10);
    const timestamp = new Date().getTime().toString(36);
    const randomId = randomChars + timestamp;
    var newNotification = {
      id: randomId,
      username: headerMsg,
      client_msg: msg,
      from_id: "voice api",
      chatType: "Error Message",
    };
    props.updateNotification(newNotification);
  };

  return (
    <>
      <ToastContainer transition={Flip} limit={2} />
      <NewIncomingRequest />
      <audio ref={audioRef} src={audiosound} />
      <audio ref={audioRef2} src={audiosound2} />
      <Navbar />
      <Sidebar />
      <Outlet />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "0px",
            padding: 1,
          },
        }}
      >
        <DialogContent sx={{ paddingBottom: "3px" }}>
          <Stack
            direction={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            spacing={1}
          >
            <img
              src={sessionExp}
              alt="sessionExp"
              height={"150px"}
              width={"150px"}
            />
            <div
              style={{ fontSize: "20px", color: "#1565C0", fontWeight: 600 }}
            >
              Your Session has Expired!
            </div>
            <div style={{ fontSize: "13px", color: "#529bea" }}>
              Do you want to continue
            </div>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Stack
            sx={{ width: "100%" }}
            alignItems={"center"}
            justifyContent={"center"}
            direction={"row"}
            spacing={2}
          >
            <Button
              variant="contained"
              size="small"
              sx={{ textTransform: "capitalize" }}
              onClick={HandleContinue}
            >
              Continue
            </Button>
            <Button
              variant="outlined"
              size="small"
              sx={{ textTransform: "capitalize" }}
              onClick={HandleLogout}
            >
              Logout
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(mapStateToProps, {
  setMsgTone,
  setMsgTone2,
  setcontactlist2,
  setVoiceRefresh,
  setShowingStatus,
  setShowingStatusVoice,
  setShowingStatusClass,
  setReadyButton,
  updateNotification,
  setAgentList,
  endInteraction,
  setinternalchatrefresh,
})(Main);
